import type { FortuneApiResponse, FortuneApiError, PeriodKind } from './types';

// 開発時は同オリジン(Vite proxy → Worker)、本番は同 zone の Pages Functions / Worker。
// VITE_API_BASE で完全 URL を上書き可能。
const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined)?.replace(/\/$/, '') ?? '';

export class ApiError extends Error {
  status: number;
  hint?: string;
  constructor(status: number, message: string, hint?: string) {
    super(message);
    this.status = status;
    this.hint = hint;
  }
}

export interface FetchFortuneArgs {
  period: PeriodKind;
  date?: string;          // YYYY-MM-DD
  birthDate?: string;
  signal?: AbortSignal;
}

export async function fetchFortune(args: FetchFortuneArgs): Promise<FortuneApiResponse> {
  const params = new URLSearchParams();
  params.set('period', args.period);
  if (args.date) params.set('date', args.date);
  if (args.birthDate) params.set('birthDate', args.birthDate);

  const url = `${API_BASE}/api/fortune?${params.toString()}`;
  const res = await fetch(url, { signal: args.signal, headers: { accept: 'application/json' } });
  const text = await res.text();
  let body: unknown;
  let parseFailed = false;
  try { body = JSON.parse(text); } catch { parseFailed = true; }

  if (parseFailed || typeof body !== 'object' || body === null) {
    throw new ApiError(
      res.status,
      'API が JSON を返しませんでした。',
      'Cloudflare Worker (/api/fortune) がデプロイされているか確認してください。Pages のみデプロイ中の場合は想定通りです。',
    );
  }
  if (!res.ok) {
    const err = body as FortuneApiError;
    throw new ApiError(res.status, err.error ?? `HTTP ${res.status}`, err.hint);
  }
  if (!('fortune' in body) || !('meishiki' in body)) {
    throw new ApiError(
      res.status,
      'API 応答の形式が想定と異なります。',
      typeof (body as { error?: unknown }).error === 'string'
        ? String((body as { error: unknown }).error).slice(0, 200)
        : undefined,
    );
  }
  return body as FortuneApiResponse;
}

export function todayInJst(): string {
  const now = new Date();
  const jst = new Date(now.getTime() + 9 * 3600 * 1000);
  const y = jst.getUTCFullYear();
  const m = String(jst.getUTCMonth() + 1).padStart(2, '0');
  const d = String(jst.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
